import { render, staticRenderFns } from "./addCorrespondenceModal.vue?vue&type=template&id=139fc6e2&"
import script from "./addCorrespondenceModal.vue?vue&type=script&lang=js&"
export * from "./addCorrespondenceModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports